import { createElement, ReactHTML } from 'react';

interface IMarkupRendererProps {
  markup: string
  type?: keyof ReactHTML
  className?: string
}

function MarkupRenderer(props: IMarkupRendererProps) {
  const {
    type = 'div',
    markup,
    className,
  } = props;

  return createElement(type, { dangerouslySetInnerHTML: { __html: markup }, className });
}

export default MarkupRenderer;
